import { toast, Zoom } from "react-toastify";

export const showToast = (message) => {
    toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        transition: Zoom,
    });
};

export const warningToast = (message) => {
    toast.warning(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        transition: Zoom,
    });
};

export const errorToast = (message) => {
    toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        transition: Zoom,
    });
};